class ProductShare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.shareUrl = String(this.dataset.shareUrl || window.location.href);
    this.shareTitle = String(this.dataset.shareTitle || document.title);
    /** @type {HTMLButtonElement | null} */
    this.nativeButton = this.querySelector('[data-share-native]');
    /** @type {HTMLButtonElement | null} */
    this.copyButton = this.querySelector('[data-share-copy]');
    /** @type {HTMLElement | null} */
    this.copyLabel = this.querySelector('[data-share-copy-label]');
    /** @type {HTMLElement | null} */
    this.status = this.querySelector('[data-share-status]');
    this.defaultCopyLabel = String(this.copyLabel?.textContent || 'Copy link');
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);

    if (this.nativeButton && typeof navigator.share === 'function') {
      this.nativeButton.hidden = false;
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    window.clearTimeout(this.resetTimer);
    delete this.dataset.initialized;
  }

  /** @param {MouseEvent} event */
  async handleClick(event) {
    if (!(event.target instanceof Element)) return;
    const nativeButton = event.target.closest('[data-share-native]');
    const copyButton = event.target.closest('[data-share-copy]');

    if (nativeButton) {
      try {
        await navigator.share({
          title: this.shareTitle,
          url: this.shareUrl,
        });
      } catch (error) {
        if (!(error instanceof DOMException) || error.name !== 'AbortError') {
          await this.copyToClipboard();
        }
      }
      return;
    }

    if (copyButton) {
      await this.copyToClipboard();
    }
  }

  async copyToClipboard() {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(this.shareUrl);
      } else {
        this.fallbackCopy();
      }
      this.announceCopied();
    } catch (error) {
      try {
        this.fallbackCopy();
        this.announceCopied();
      } catch (fallbackError) {
        this.announce('Unable to copy the link.');
      }
    }
  }

  fallbackCopy() {
    const input = document.createElement('textarea');
    input.value = this.shareUrl;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    if (!copied) throw new Error('Copy command failed');
  }

  announceCopied() {
    this.announce('Link copied.');
    if (this.copyLabel) this.copyLabel.textContent = 'Copied';

    window.clearTimeout(this.resetTimer);
    this.resetTimer = window.setTimeout(() => {
      if (this.copyLabel) this.copyLabel.textContent = this.defaultCopyLabel;
    }, 2000);
  }

  /** @param {string} message */
  announce(message) {
    if (this.status) this.status.textContent = message;
  }
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', ProductShare);
}
